import React, { FC, useState } from 'react';
import { KFTooltip } from '@kf/ic2fx';
import { useTranslation } from 'react-i18next';
import ThumbsUpDownIcon from 'shared/icons/ThumbsUpDownIcon';
interface IThumbsUpDownWidget {
  thumbsUpAction?: () => void;
  thumbsDownAction?: () => void;
}

const IconWithTooltip = ({
  action,
  variant,
}: {
  action: () => void;
  variant?: 'up' | 'down';
}) => {
  const { t } = useTranslation();
  const [strokeForThumbsUp, setStrokeForThumbsup] = useState('#243D42');
  return (
    <KFTooltip
      variant='v2'
      title=''
      color='dark'
      body={variant === 'up' ? t('recommend').toString() : t('passOn').toString()}
      id={variant === 'up' ? 'thumbsup' : 'thumbsdown'} 
      data-testid={variant === 'up' ? 'thumbsup' : 'thumbsdown'}
      style={{ display: 'flex' }}
      tabIndex={1}
      aria-label={variant === 'up' ? 'thumbsup' : 'thumbsdown'}
    >
      <span
        onClick={() => action && action()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') action && action();
        }}
        style={{ display: 'flex', cursor: 'pointer' }}
        onMouseOver={() => setStrokeForThumbsup('#008369')}
        onMouseLeave={() => setStrokeForThumbsup('#243D42')}
        onFocus={() => setStrokeForThumbsup('#008369')}
        onBlur={() => setStrokeForThumbsup('#243D42')}
      >
        <ThumbsUpDownIcon
          stroke={strokeForThumbsUp}
          rotate={variant === 'up' ? '' : 'true'}
        />
      </span>
    </KFTooltip>
  );
};

const ThumbsUpDownWidget: FC<IThumbsUpDownWidget> = ({
  thumbsUpAction,
  thumbsDownAction,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        background: 'white',
        borderRadius: '1.25rem',
        columnGap: '0.75rem',
        width: '5.4rem',
        height: '2.5rem',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconWithTooltip variant='up' action={() => thumbsUpAction?.()} />
      <IconWithTooltip action={() => thumbsDownAction?.()} />
    </div>
  );
};

export default ThumbsUpDownWidget;
